import React from 'react';
import { PageTemplate } from '@/components/molecules/PageTemplate';

export const HelpSupport: React.FC = () => {
  return (
    <PageTemplate
      title="Help & Support"
      description="Get help and support for nCoder AI"
    />
  );
};

export default HelpSupport;